/**
 * システム管理API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 権限ユーザ・グループリスト
 */
export interface AuthorityUserGroupDto { 
    /**
     * ユーザID
     */
    userId?: string;
    /**
     * グループコード
     */
    groupCd?: string;
    /**
     * 更新通番号
     */
    updateSerialNo?: string;
}

